<sw-tabs default-item="general">
    <template #default="{ active }">
        <sw-tabs-item
            name="general"
            :activeTab="active"
        >
            {{ $tc('sw-cms.elements.moorl-usp.tab.general') }}
        </sw-tabs-item>
        <sw-tabs-item
            name="textColor"
            :activeTab="active"
        >
            {{ $tc('sw-cms.elements.moorl-usp.tab.textColor') }}
        </sw-tabs-item>
    </template>

    <template #content="{ active }">
        <sw-container
            v-if="active === 'general'"
            class="sw-cms-el-config-moorl-usp__tab-general"
        >
            <mt-switch
                v-model="element.config.iconActive.value"
                bordered
                :label="$tc('sw-cms.elements.moorl-usp.config.iconActive')"
            />
            <mt-text-field
                v-if="element.config.iconActive.value"
                v-model="element.config.iconClass.value"
                placeholder="fab|shopware"
                :helpText="$tc('sw-cms.elements.moorl-usp.config.iconClassHelpText')"
                :label="$tc('sw-cms.elements.moorl-usp.config.iconClass')"
            />
            <mt-text-field
                v-model="element.config.title.value"
                :label="$tc('sw-cms.elements.moorl-usp.config.headline')"
            />
            <mt-text-field
                v-model="element.config.text.value"
                :label="$tc('sw-cms.elements.moorl-usp.config.subHeadline')"
            />
            <moorl-select-field
                :label="$tc('sw-cms.elements.moorl-usp.config.alignment')"
                v-model:value="element.config.alignment.value"
                set="textHorizontalAlign"
                :filter="['left','center']"
            />
        </sw-container>
        <sw-container
            v-if="active === 'textColor'"
            class="sw-cms-el-config-moorl-usp__tab-colors"
        >
            <mt-colorpicker
                colorOutput="hex"
                :zIndex="1000"
                :label="$tc('sw-cms.elements.moorl-usp.config.iconColor')"
                v-model="element.config.iconColor.value"
            />
            <mt-colorpicker
                colorOutput="hex"
                :zIndex="1000"
                :label="$tc('sw-cms.elements.moorl-usp.config.headlineColor')"
                v-model="element.config.headlineColor.value"
            />
            <mt-colorpicker
                colorOutput="hex"
                :zIndex="1000"
                :label="$tc('sw-cms.elements.moorl-usp.config.subHeadlineColor')"
                v-model="element.config.subHeadlineColor.value"
            />
        </sw-container>
    </template>
</sw-tabs>